// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var ETasksExecution;
(function (ETasksExecution) {
    ETasksExecution["EXPORT_ELECTION_EVENT"] = "EXPORT_ELECTION_EVENT";
    ETasksExecution["EXPORT_TENANT_CONFIG"] = "EXPORT_TENANT_CONFIG";
    ETasksExecution["IMPORT_TENANT_CONFIG"] = "IMPORT_TENANT_CONFIG";
    ETasksExecution["EXPORT_TRUSTEES"] = "EXPORT_TRUSTEES";
    ETasksExecution["IMPORT_CANDIDATES"] = "IMPORT_CANDIDATES";
    ETasksExecution["IMPORT_USERS"] = "IMPORT_USERS";
    ETasksExecution["EDIT_USER"] = "EDIT_USER";
    ETasksExecution["CREATE_ELECTION_EVENT"] = "CREATE_ELECTION_EVENT";
    ETasksExecution["IMPORT_ELECTION_EVENT"] = "IMPORT_ELECTION_EVENT";
    ETasksExecution["EXPORT_VOTERS"] = "EXPORT_VOTERS";
    ETasksExecution["CREATE_TRANSMISSION_PACKAGE"] = "CREATE_TRANSMISSION_PACKAGE";
    ETasksExecution["EXPORT_BALLOT_PUBLICATION"] = "EXPORT_BALLOT_PUBLICATION";
    ETasksExecution["EXPORT_ACTIVITY_LOGS_REPORT"] = "EXPORT_ACTIVITY_LOGS_REPORT";
    ETasksExecution["GENERATE_REPORT"] = "GENERATE_REPORT";
    ETasksExecution["GENERATE_TRANSMISSION_REPORT"] = "GENERATE_TRANSMISSION_REPORT";
    ETasksExecution["EXPORT_APPLICATION"] = "EXPORT_APPLICATION";
    ETasksExecution["IMPORT_APPLICATION"] = "IMPORT_APPLICATION";
    ETasksExecution["RENDER_DOCUMENT_PDF"] = "RENDER_DOCUMENT_PDF";
    ETasksExecution["CREATE_TEMANT"] = "CREATE_TENANT";
    ETasksExecution["EXPORT_TEMPLATES"] = "EXPORT_TEMPLATES";
    ETasksExecution["IMPORT_TEMPLATES"] = "IMPORT_TEMPLATES";
    ETasksExecution["DELETE_ELECTION_EVENT"] = "DELETE_ELECTION_EVENT";
    ETasksExecution["DELETE_VOTERS"] = "DELETE_VOTERS";
    ETasksExecution["PREPARE_PUBLICATION_PREVIEW"] = "PREPARE_PUBLICATION_PREVIEW";
    ETasksExecution["EXPORT_TALLY_RESULTS_XLSX"] = "EXPORT_TALLY_RESULTS_XLSX";
    ETasksExecution["EXPORT_CERTIFICATE_AUTHORITIES"] = "EXPORT_CERTIFICATE_AUTHORITIES";
    ETasksExecution["PUBLISH_RESULTS_WEBSITE"] = "PUBLISH_RESULTS_WEBSITE";
    ETasksExecution["GENERATE_RECONCILIATION_PATCHES"] = "GENERATE_RECONCILIATION_PATCHES";
    ETasksExecution["APPLY_RECONCILIATION_PATCH"] = "APPLY_RECONCILIATION_PATCH";
    ETasksExecution["PUBLISH_BALLOT"] = "PUBLISH_BALLOT";
    ETasksExecution["VOTER_INFORMATION_LETTER"] = "VOTER_INFORMATION_LETTER";
})(ETasksExecution || (ETasksExecution = {}));
